import type { ApiResponse } from "../../../shared/types/api";
import { httpClient } from "../http-client";
import { NEW_API_ENDPOINTS } from "../../../shared/constants/api";
import type {
  CompanyPlugin,
  CompanyPluginConfigMap,
  CompanyPluginType,
} from "../../../domain/types/company-plugin";

export class CompanyPluginApiService {
  /** 등록된 플러그인 목록 (등록 순) */
  async getPlugins(companyId: number): Promise<ApiResponse<CompanyPlugin[]>> {
    const response = await httpClient.get<ApiResponse<CompanyPlugin[]>>(
      NEW_API_ENDPOINTS.companyPluginController.LIST(companyId),
    );

    if (response.data.errorCode) {
      throw new Error(
        response.data.errorMsg || "연동 서비스 목록을 가져오지 못했습니다.",
      );
    }

    return response.data;
  }

  /** 플러그인 등록 또는 수정 (없으면 등록, 있으면 설정 교체) */
  async savePlugin<T extends CompanyPluginType>(
    companyId: number,
    pluginType: T,
    config: CompanyPluginConfigMap[T],
  ): Promise<ApiResponse<CompanyPlugin>> {
    const response = await httpClient.put<ApiResponse<CompanyPlugin>>(
      NEW_API_ENDPOINTS.companyPluginController.PUT(companyId, pluginType),
      config,
    );

    if (response.data.errorCode) {
      throw new Error(
        response.data.errorMsg || "연동 서비스 저장에 실패했습니다.",
      );
    }

    return response.data;
  }

  /** 연동 해제 */
  async deletePlugin(
    companyId: number,
    pluginType: CompanyPluginType,
  ): Promise<ApiResponse<boolean>> {
    const response = await httpClient.delete<ApiResponse<boolean>>(
      NEW_API_ENDPOINTS.companyPluginController.DELETE(companyId, pluginType),
    );

    if (response.data.errorCode) {
      throw new Error(
        response.data.errorMsg || "연동 해제에 실패했습니다.",
      );
    }

    return response.data;
  }
}

export const companyPluginApiService = new CompanyPluginApiService();
